import * as React from 'react';
import { connect } from 'react-redux';
import * as UserModule from './../../../Modules/UserModule';
import ResetPasswordForm from '../Forms/_ResetPasswordForm';

type Props = {};

type ConnectedDispatch = {
    resetPassword: Function;
};
type ConnectedProps = {
    UserStore: UserModule.Types.UserStore;
};
type State = {
    //
};

class RestartPassword extends React.Component<Props & ConnectedDispatch & ConnectedProps, State> {
    constructor(props: Props & ConnectedDispatch & ConnectedProps) {
        super(props);
        this.resetPassword = this.resetPassword.bind(this);
    }
    private async resetPassword(formData: UserModule.Types.RequestPasswordResetRequest) {
        await this.props.resetPassword(formData);
    }
    public render() {
        return (
            <div className="login__inner">
                <h1>
                    GPS
                    <br />
                    <span>Tracking</span>
                </h1>
                <ResetPasswordForm onSubmit={this.resetPassword} />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        resetPassword: (formData: UserModule.Types.RequestPasswordResetRequest) => dispatch(UserModule.Actions.resetPassword(formData))
    };
}

export default connect(
    null,
    mapDispatchToProps
)(RestartPassword) as React.ComponentClass<Props>;
// export default RestartPassword;



// WEBPACK FOOTER //
// ./src/components/UserSigning/ResetPassword/_RestartPassword.tsx